import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import StaffsComponent1 from '../../uiElements/staffsComponents/staffsComponent1/StaffsComponent1';

const Staffs1 = (props) => {
    const { staffs, loadingSpinner } = props;

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb="Executive Board" marginLeft="100px" />
            <StaffsComponent1 staffs={staffs} loadingSpinner={loadingSpinner} />
        </>
    );
};

Staffs1.propTypes = {
    staffs: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Staffs1);
